/**
 * @generated SignedSource<<7b5642a6df9034d2d34d2a6608490319>>
 * @relayHash eea309a55a662ee2fefe21d11fcbfef3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 57f1daad90f813b503ba209933229040828ceaf2dc74d446698a7142923e0a05

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HelpCenterManagementAppQuery } from './HelpCenterManagementAppQuery.graphql';

const node: PreloadableConcreteRequest<HelpCenterManagementAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "57f1daad90f813b503ba209933229040828ceaf2dc74d446698a7142923e0a05",
    "metadata": {},
    "name": "HelpCenterManagementAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
